var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lib-container comments-box"},[_c('el-alert',{staticClass:"desc-alert",attrs:{"title":"留言板","type":"success","closable":false,"center":""}}),_c('div',{attrs:{"id":"vcomments"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }